import { render, staticRenderFns } from "./AdmEditPixDetail.vue?vue&type=template&id=5aabd793&scoped=true&"
import script from "./AdmEditPixDetail.vue?vue&type=script&lang=js&"
export * from "./AdmEditPixDetail.vue?vue&type=script&lang=js&"
import style0 from "./AdmEditPixDetail.vue?vue&type=style&index=0&id=5aabd793&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aabd793",
  null
  
)

export default component.exports